module.exports = __webpack_public_path__ + "static/dolla-5976032af81ef3c34b29131f12207eba.jpg";